import { OddResponse, NormalizedOdd } from '../types/odds';
import { MarketWithTypeKey, ScopeTypes } from '../types/markets';
import { OddsMarketTypes } from '../../types/common';

// return odds markets array as an object with market types keys
export const mapOddsMarketsWithDifferentKeys = (odds: OddResponse[]): NormalizedOdd[] => {
  if (!odds || odds.length === 0) return [];

  const transformedOdds = odds.map((odd: OddResponse) => {
    const mappedMarketsWithNewKeys: MarketWithTypeKey = {};

    if (!odd?.markets?.length) return { ...odd, markets: {} };

    for (const market of odd.markets) {
      if (!market.type.code) continue;

      if (market.type.code === OddsMarketTypes.ONEXTWO) {
        switch (market.scope.type.toUpperCase()) {
          case ScopeTypes.FULL_TIME:
            mappedMarketsWithNewKeys[ScopeTypes.FULL_TIME] = market;
            break;
          case ScopeTypes.FIRST_HALF:
            mappedMarketsWithNewKeys[ScopeTypes.FIRST_HALF] = market;
            break;
          case ScopeTypes.SECOND_HALF:
            mappedMarketsWithNewKeys[ScopeTypes.SECOND_HALF] = market;
            break;
          default:
            mappedMarketsWithNewKeys[OddsMarketTypes.ONEXTWO] = market;
        }
      } else {
        mappedMarketsWithNewKeys[market.type.code as keyof MarketWithTypeKey] = market;
      }
    }

    return {
      ...odd,
      markets: mappedMarketsWithNewKeys,
    };
  });

  return transformedOdds;
};
